import React from "react";
import {
  // Nav,
  Navbar,
  // NavDropdown
} from "react-bootstrap";
import logo64 from "../../assest/img/logo64.png";

const NavBar = () => {
  return (
    <>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Navbar.Brand href="#home">
          <img
            alt="Logo"
            src={logo64}
            width="30"
            height="30"
            className="d-inline-block align-top"
          />
          {"  "}
          Delivery Challan AtDoor
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        {/* <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Link href="#features">Print Preview</Nav.Link>
            <Nav.Link href="#pricing">Download</Nav.Link>
            <NavDropdown title="Share" id="collasible-nav-dropdown">
              <NavDropdown.Item href="#action/3.2">Whatsapp</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Telegram</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">SMS</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse> */}
      </Navbar>
    </>
  );
};

export default NavBar;
